import { render, staticRenderFns } from "./PekerjaanItem.vue?vue&type=template&id=652612a5&scoped=true&"
import script from "./PekerjaanItem.vue?vue&type=script&lang=js&"
export * from "./PekerjaanItem.vue?vue&type=script&lang=js&"
import style0 from "./PekerjaanItem.vue?vue&type=style&index=0&id=652612a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652612a5",
  null
  
)

export default component.exports